import {
  fallbackLanguage,
  LocalizedString,
  LocalizedStringOptions,
} from '@griply/types';

export const getLocalizedStringValue = (
  localizedString: string | LocalizedString,
  languageRegion: string,
) => {
  if (typeof localizedString === 'string' || !localizedString) {
    return localizedString;
  }

  if (localizedString[languageRegion as LocalizedStringOptions]) {
    return localizedString[languageRegion as LocalizedStringOptions];
  }

  const language = languageRegion.split('-')[0] as LocalizedStringOptions;

  if (localizedString[language]) {
    return localizedString[language];
  }

  return localizedString[fallbackLanguage];
};
